import React, { FC } from "react";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
export interface SearchSectionHeroProps {
  className?: string;
}

const SearchSectionHero: FC<SearchSectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse h-24 lg:pt-8 lg:flex-col relative ${className}`}
      data-nc-id="SearchSectionHero"
    >
      <div className="z-10 md:mb-12 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SearchSectionHero;
